import { render, staticRenderFns } from "./TheNavigation.vue?vue&type=template&id=4bf38aee"
import script from "./TheNavigation.vue?vue&type=script&lang=js"
export * from "./TheNavigation.vue?vue&type=script&lang=js"
import style0 from "./TheNavigation.vue?vue&type=style&index=0&id=4bf38aee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports